// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageHeader_wrapper__1nsTD","breadcrumbs":"PageHeader_breadcrumbs__DVdLC","marginLarge":"PageHeader_marginLarge__19rA2","isWhite":"PageHeader_isWhite__2iw1e"};